import './App.css';
import Header from './Components/Header';

function App() {
  return (
    <>
      <Header/>
    </>
  );
}

export default App;
